// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.MeetingMeToGetTurn {\r\n  color: black;\n}\n.botton-actions {\r\n  position: absolute;\r\n  top: 1.25rem;\r\n  /* width: 100%; */\r\n  left: -1rem;\n}\n.form-data {\r\n  margin-top: 40px;\r\n  background-color: #f9f9f9;\r\n  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));\r\n  border-radius: 21.4881px;\n}\r\n", ""]);
// Exports
module.exports = exports;
